if (!customElements.get('cart-address-guide')) {
  customElements.define(
    'cart-address-guide',
    class CartAddressGuide extends HTMLElement {
      constructor() {
        super();
        this.inputs = this.querySelectorAll('[data-attribute]');
        this.addEventListener('input', debounce(this.onInput.bind(this), 300));
      }

      onInput() {
        const attributes = {};
        this.inputs.forEach((input) => {
          attributes[input.dataset.attribute] = input.value;
        });

        fetch(window.routes.cart_update_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes }),
        }).catch((error) => {
          console.error(error);
        });
      }
    }
  );
}
